import EmptyIcon from '../assets/img/empty.png';
import { ReactNode } from 'react';
import {
  CSSObject,
  Flex,
  Image,
  Text,
  useMultiStyleConfig,
} from '@chakra-ui/react';

export interface EmptyProps {
  icon?: ReactNode;
  iconProps?: CSSObject;
  description?: ReactNode;
  descriptionProps?: CSSObject;
  children?: ReactNode;
  containerProps?: CSSObject;
}

export const Empty = (props: EmptyProps) => {
  const {
    icon,
    iconProps,
    description = 'No Data',
    descriptionProps,
    children,
    containerProps,
  } = props;
  const styles = useMultiStyleConfig('Empty', props);

  return (
    <Flex sx={{ ...styles.Container, ...containerProps }}>
      {icon ? (
        icon
      ) : (
        <Image src={EmptyIcon} sx={{ ...styles.Icon, ...iconProps }} />
      )}
      <Text sx={{ ...styles.Description, ...descriptionProps }}>
        {description}
      </Text>
      {children}
    </Flex>
  );
};
